import React, { useContext, useState } from "react";
import { DatePicker, Select } from "antd";
import { isEmpty } from "lodash";
import moment from "moment";

import { ExpenseReportsContext } from "./ExpenseReportsContext";

import { EXPENSE_STATUS_ID_TO_LABEL } from "../../../configs/constants";
import { fetchExpensesDisctinctClients, fetchExpensesDisctinctUsers, fetchExpensesDisctinctType } from "../api/api";

const Option = Select.Option;

const ExpenseReportsFilters = ({}) => {
  const {
    setSelectedType,
    selectedType,
    userRoleId,
    requestFetchExpenseReportWeekly,
    token,
    onChangeView,
    weekDate,
    onChangeWeekDate,
    onChangeRangeDate,
    isDetailsViewActive,
    isWeeklyViewActive,
    selectedStatus,
    setSelectedStatus,
    selectedUserEmail,
    setSelectedUserEmail,
    rangeDate,
    selectedClient,
    setSelectedClient,
    setRangeDate,
    hideNotInWorkforce
  } = useContext(ExpenseReportsContext);

  const [listUsers, setListUsers] = useState([]);
  const [listClients, setListClients] = useState([]);
  const [listTypes, setListTypes] = useState([]);
  // const getUsersList = () => {
  //   return expenseReportsList
  //     ? expenseReportsList.reduce((acc, expenseReport) => {
  //         if (!acc.includes(expenseReport.user_email)) acc.push(expenseReport.user_email);
  //         return acc;
  //       }, [])
  //     : [];
  // };

  const onChangeFilterUser = emailSelected => {
    if (isWeeklyViewActive)
      requestFetchExpenseReportWeekly(
        {
          match: {
            email: emailSelected
          },
          page: 1
        },
        weekDate
      );
    if (emailSelected) setSelectedUserEmail(emailSelected);
    else {
      if (isWeeklyViewActive) requestFetchExpenseReportWeekly({ page: 1 }, weekDate);
      setSelectedUserEmail(null);
    }
  };

  const onChangeFilterClient = client => {
    if (isWeeklyViewActive)
      requestFetchExpenseReportWeekly(
        {
          match: {
            ["clients.label"]: client
          },
          page: 1
        },
        weekDate
      );
    if (client) setSelectedClient(client);
    else {
      if (isWeeklyViewActive) requestFetchExpenseReportWeekly({ page: 1 }, weekDate);
      setSelectedClient(null);
    }
  };

  const onChangeFilterType = value => {
    if (value) setSelectedType(value);
    else setSelectedType(null);
  };

  return (
    <div className={"my-3 flex"}>
      {isDetailsViewActive || isWeeklyViewActive ? (
        <div className="flex justify-between">
          <button
            className="bg-gray-200 mr-5 rounded-full h-10 w-10 flex items-center justify-center mr-4"
            style={{ outline: "none" }}
            onClick={() => onChangeWeekDate(moment(weekDate).subtract(7, "d"))}
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ffffff"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <DatePicker.WeekPicker value={weekDate} onChange={onChangeWeekDate} placeholder="Sélectionner une semaine" />
          <button
            className="bg-gray-200 mr-5 rounded-full h-10 w-10 flex items-center justify-center ml-4"
            style={{ outline: "none" }}
            onClick={() => onChangeWeekDate(moment(weekDate).add(7, "d"))}
          >
            <svg
              transform="rotate(180)"
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="#ffffff"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>
      ) : (
        <DatePicker.RangePicker
          onChange={selectedRangeDate => {
            setRangeDate(selectedRangeDate);
            onChangeRangeDate(selectedRangeDate);
          }}
          defaultValue={rangeDate}
          format={"DD/MM/YYYY"}
          placeholder={["Début", "Fin"]}
        />
      )}
      {userRoleId < 4 && (
        <div className="mx-2">
          <Select
            allowClear={!isDetailsViewActive}
            showSearch
            placeholder="Personne"
            style={{ width: 200 }}
            value={selectedUserEmail ? selectedUserEmail : []}
            onFocus={async () => {
              // const filters = {
              //   match: {
              //     clients: { $exists: true, $ne: [] }
              //   }
              // };
              // if (selectedUserEmail) filters.match["clients.id"] = selectedUserEmail;

              const response = await fetchExpensesDisctinctUsers({ hideNotInWorkforce }, token);
              setListUsers(response);
            }}
            onChange={email => onChangeFilterUser(email)}
          >
            {!isEmpty(listUsers) &&
              listUsers.sort().map(userEmail => (
                <Option key={userEmail} value={userEmail}>
                  {userEmail}
                </Option>
              ))}
          </Select>
        </div>
      )}
      {!isDetailsViewActive && (
        <div className="mx-2">
          <Select
            allowClear={true}
            // allowClear={!isDetailsViewActive}
            showSearch
            placeholder="Dossier"
            style={{ width: 200 }}
            value={selectedClient ? selectedClient : undefined}
            onFocus={async () => {
              const response = await fetchExpensesDisctinctClients({}, token);
              setListClients(response);
            }}
            onChange={client => onChangeFilterClient(client)}
          >
            {!isEmpty(listClients) &&
              listClients.sort().map(client => (
                <Option key={client} value={client}>
                  {client}
                </Option>
              ))}
          </Select>
        </div>
      )}
      {!isWeeklyViewActive && !isDetailsViewActive && (
        <div className="mx-2">
          <Select
            allowClear
            placeholder="Statut de la demande"
            style={{ width: 200 }}
            onChange={setSelectedStatus}
            value={selectedStatus}
          >
            {!isEmpty(Object.values(EXPENSE_STATUS_ID_TO_LABEL)) &&
              Object.values(EXPENSE_STATUS_ID_TO_LABEL)
                .sort()
                .map(status => (
                  <Option key={status} value={status}>
                    {status}
                  </Option>
                ))}
          </Select>
        </div>
      )}
      {!isDetailsViewActive && !isWeeklyViewActive && (
        <div className="mx-2">
          <Select
            allowClear={true}
            // allowClear={!isDetailsViewActive}
            showSearch
            placeholder="Type"
            style={{ width: 200 }}
            value={selectedType ? selectedType : undefined}
            onFocus={async () => {
              const response = await fetchExpensesDisctinctType({}, token);

              setListTypes(response);
            }}
            onChange={item => onChangeFilterType(item)}
          >
            {!isEmpty(listTypes) &&
              listTypes.sort().map(expenseType => (
                <Option key={expenseType} value={expenseType}>
                  {expenseType}
                </Option>
              ))}
          </Select>
        </div>
      )}
      {!isDetailsViewActive && (
        <div
          className={"bg-orange-500 rounded-full text-white py-3 px-4 mx-2 cursor-pointer"}
          onClick={() => onChangeView()}
        >
          {isWeeklyViewActive ? "Vue liste" : "Vue semaine"}
        </div>
      )}
    </div>
  );
};

export default ExpenseReportsFilters;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/ExpenseReportsFilters.js